/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Admin_Desc5Inputs */

const en_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teach the bot, review chats and step in live from one dashboard.`)
};

const ar_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`علّم البوت وراجع المحادثات وتدخل مباشرة من لوحة واحدة.`)
};

const bn_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বটকে নতুন শেখান, চ্যাট দেখুন আর এক ড্যাশবোর্ড থেকে লাইভ হস্তক্ষেপ করুন।`)
};

const de_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bringen Sie dem Bot Neues bei, prüfen Sie Chats und greifen Sie live über ein Dashboard ein.`)
};

const es_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseñar al bot, revisar chats e intervenir en vivo desde un solo panel.`)
};

const fr_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formez le bot, relisez les chats et intervenez en direct depuis un seul tableau de bord.`)
};

const pt_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ensine coisas novas ao bot, reveja chats e intervenha ao vivo num só painel.`)
};

const zh_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教机器人新知识、查看聊天记录，并从一个后台实时介入。`)
};

const tr_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bota yenilikler öğretin, sohbetleri inceleyin, tek panelden canlı müdahale edin.`)
};

const ru_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учите бота новому, проверяйте чаты и вмешивайтесь вживую из одной панели.`)
};

const pl_svc_messaging_bots_admin_desc5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ucz bota nowego, przeglądaj czaty i interweniuj na żywo z jednego panelu.`)
};

/**
* | output |
* | --- |
* | "Teach the bot, review chats and step in live from one dashboard." |
*
* @param {Svc_Messaging_Bots_Admin_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_admin_desc5 = /** @type {((inputs?: Svc_Messaging_Bots_Admin_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Admin_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "de") return de_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "es") return es_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_admin_desc5(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_admin_desc5(inputs)
	return en_svc_messaging_bots_admin_desc5(inputs)
});
export { svc_messaging_bots_admin_desc5 as "svc_messaging-bots_ADMIN_desc" }